import type {
  ChatAction,
  ChatErrorAction,
  CustomizationEnablementKind,
  ErrorInfo,
  ResponsePartKind,
  SessionAction,
  SessionCustomizationToggledAction,
} from '@microsoft/agent-host-protocol'

type LegacyChatErrorAction = Omit<ChatErrorAction, 'part'> & {error: ErrorInfo}
type LegacyCustomizationToggledAction = Omit<SessionCustomizationToggledAction, 'enablement'> & {enabled: boolean}

// Negotiating an older wire version does not translate actions for the 0.9 reducers.
export function normalizeChatAction(action: ChatAction | LegacyChatErrorAction): ChatAction {
  if (action.type !== 'chat/error' || 'part' in action) return action
  return {...action, part: {kind: 'error' as ResponsePartKind.Error, error: action.error}}
}

export function normalizeSessionAction(action: SessionAction | LegacyCustomizationToggledAction): SessionAction {
  if (action.type !== 'session/customizationToggled' || 'enablement' in action) return action
  return {
    ...action,
    enablement: [{kind: 'global' as CustomizationEnablementKind.Global, enabled: action.enabled}],
  }
}
